class ArmourHeaderNavigation extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.addEventListener('armour:navigation', event => {
      if (event.detail.open) for (const item of this.querySelectorAll('armour-nav-item')) if (item !== event.target) item.toggle(false);
      const scrim = this.querySelector('.armour-nav__scrim');
      if (scrim) scrim.hidden = ![...this.querySelectorAll('summary')].some(summary => summary.getAttribute('aria-expanded') === 'true');
    }, { signal });
    this.querySelector('.armour-nav__scrim')?.addEventListener('click', () => this.close(), { signal });
    document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) this.close(); }, { signal });
    this.breakpoint = matchMedia('(min-width: 1366px)');
    this.breakpoint.addEventListener('change', () => { this.close(); if (this.breakpoint.matches) this.closest('header-sidebar')?.hide(); }, { signal });
    this.closest('header-sidebar')?.addEventListener('dialog:after-hide', () => this.close(), { signal });
  }
  close() { for (const item of this.querySelectorAll('armour-nav-item')) item.toggle(false); }
  disconnectedCallback() { this.controller?.abort(); }
}
class ArmourNavItem extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.details = this.querySelector('details');
    this.trigger = this.querySelector('summary');
    this.panel = this.querySelector('.armour-nav__panel');
    this.trigger.addEventListener('click', event => { event.preventDefault(); this.toggle(this.trigger.getAttribute('aria-expanded') !== 'true'); }, { signal });
    this.addEventListener('keydown', event => {
      if (event.key === 'Escape' && this.trigger.getAttribute('aria-expanded') === 'true') { event.preventDefault(); if (this.dataset.mode === 'desktop') event.stopPropagation(); this.toggle(false); this.trigger.focus(); }
    }, { signal });
    this.addEventListener('focusout', event => {
      if (event.relatedTarget && !this.contains(event.relatedTarget)) this.toggle(false);
    }, { signal });
    this.addEventListener('pointerenter', event => {
      if (this.dataset.mode !== 'desktop' || event.pointerType !== 'mouse' || !matchMedia('(hover: hover)').matches) return;
      clearTimeout(this.timer); this.timer = setTimeout(() => this.toggle(true), 175);
    }, { signal });
    this.addEventListener('pointerleave', event => {
      if (this.dataset.mode !== 'desktop' || event.pointerType !== 'mouse') return;
      clearTimeout(this.timer); this.timer = setTimeout(() => { if (!this.contains(document.activeElement)) this.toggle(false); }, 200);
    }, { signal });
  }
  toggle(open) {
    if (!this.trigger) return;
    clearTimeout(this.timer);
    if ((this.trigger.getAttribute('aria-expanded') === 'true') === open) return;
    const wasOpen = this.details.open;
    const style = getComputedStyle(this.panel);
    const start = { opacity: wasOpen ? style.opacity : '0', transform: wasOpen ? style.transform : 'translateY(-4px)' };
    if (this.dataset.mode === 'mobile') start.height = wasOpen ? `${this.panel.getBoundingClientRect().height}px` : '0px';
    this.animation?.cancel();
    this.details.open = true;
    this.trigger.setAttribute('aria-expanded', String(open));
    this.panel.inert = !open;
    this.dispatchEvent(new CustomEvent('armour:navigation', { bubbles: true, detail: { open } }));
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { this.details.open = open; return; }
    const end = { opacity: open ? '1' : '0', transform: open ? 'translateY(0)' : 'translateY(-4px)' };
    if (this.dataset.mode === 'mobile') end.height = open ? `${this.panel.getBoundingClientRect().height}px` : '0px';
    const animation = this.panel.animate([start, end], { duration: open ? 220 : 180, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'both' });
    this.animation = animation;
    animation.onfinish = () => { this.details.open = open; animation.cancel(); this.animation = null; };
  }
  disconnectedCallback() { clearTimeout(this.timer); this.animation?.cancel(); this.controller?.abort(); }
}
if (!customElements.get('armour-header-navigation')) customElements.define('armour-header-navigation', ArmourHeaderNavigation);
if (!customElements.get('armour-nav-item')) customElements.define('armour-nav-item', ArmourNavItem);
